(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.web.view.core
  (:require
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.web.view.debt-financing
    :refer [debt-financing-section]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.web.view.details-and-figures
    :refer [details-and-figures-section]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.web.view.financial-statement
    :refer [financial-statements-section]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.web.view.overview
    :refer [overview-section]]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.web.view.tearsheet
    :refer
    [tearsheet-section]]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.common.view :as re]))

(defn real-estate-body
  [{:keys [fund-ui-data] :as props}]
  (let [{:keys [tearsheet
                overview
                esg
                debt-financing
                details-and-figures
                financial-statements]}
        fund-ui-data]

    [:div
     ^{:key :tearsheet}
     [:div
      [tearsheet-section tearsheet props]]
     ^{:key :overview}
     [:div {}
      [overview-section overview props]]
     ^{:key :esg}
     [:div
      [re/esg-section esg props]]
     ^{:key :details-and-figures}
     [:div
      [details-and-figures-section details-and-figures props]]
     ^{:key :debt-financing}
     [:div
      [debt-financing-section debt-financing props]] 
     ^{:key :financial-statements}
     [:div
      [financial-statements-section financial-statements props]]]))
